export default __webpack_public_path__ + "38df79a8fc05397e1413c06155deed3b.jpg";